import _some from "lodash/some";
import _filter from "lodash/filter";
import _get from "lodash/get";
import moment from 'moment';
import { createSelector } from 'reselect';
import { myBills as myBillsUtils } from "../utils";
import { DATE_FORMAT } from "../constants";

var getDateFromProps = function getDateFromProps(state, props) {
  return _get(props, 'date');
};

export var getWorkingSuggestedBills = function getWorkingSuggestedBills(identity) {
  return _get(identity, 'myBills.workingSuggestedBills');
};
export var getStagedBills = createSelector([getWorkingSuggestedBills], function (suggestedBills) {
  if (!suggestedBills) {
    return null;
  }

  return _filter(suggestedBills, 'isStaged');
});
export var getMyBills = function getMyBills(identity) {
  return _get(identity, 'myBills.myBills');
};

var getBillIdFromProps = function getBillIdFromProps(state, props) {
  return props.billId;
};

export var makeGetBillById = function makeGetBillById() {
  return createSelector([getMyBills, getBillIdFromProps], function (myBills, billId) {
    return myBillsUtils.findBillById(myBills, billId);
  });
};
export var getMyUpcomingBills = createSelector([getMyBills, getDateFromProps], function (myBills, date) {
  var firstOfThisMonth = moment(date).startOf('month').format(DATE_FORMAT.STANDARD);
  var lastOfNextMonth = moment(date).add(1, 'month').endOf('month').format(DATE_FORMAT.STANDARD);
  return myBillsUtils.createBillInstances(myBills, firstOfThisMonth, lastOfNextMonth);
});

var getDeleteBillPendingRequests = function getDeleteBillPendingRequests(identity) {
  return _get(identity, 'requests.deleteBill.pendingRequests');
};

export var makeGetIsBillDeleting = function makeGetIsBillDeleting() {
  return createSelector([getDeleteBillPendingRequests, getBillIdFromProps], function (requests, billId) {
    return _some(requests, {
      billId: billId
    });
  });
};
export var getRemainingBillsTotal = createSelector([getMyUpcomingBills, getDateFromProps], function (upcomingBills, date) {
  var today = moment(date).format(DATE_FORMAT.STANDARD);
  var lastOfCurrentMonth = moment(date).endOf('month').format(DATE_FORMAT.STANDARD);
  return myBillsUtils.computeUpcomingBillsTotal(upcomingBills, today, lastOfCurrentMonth);
});